enum OrderTypeEnum {
  BUY = 1,
  SELL = 2,
  AUCTION = 3,
}

export enum OrderTypeEnumString {
  BUY = "BUY",
  SELL = "SELL",
  AUCTION = "AUCTION",
}

export default OrderTypeEnum;
